'use client';

import { type ReactNode, createContext, useContext } from 'react';

// AI-related functionality removed for this branch
// Settings dialog and provider are disabled when AI is not supported

interface SettingsContextType {
  keys: Record<string, string>;
  setKey: (service: string, key: string) => void;
}

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined
);

export function SettingsProvider({ children }: { children: ReactNode }) {
  // Minimal provider for compatibility - no actual functionality
  const setKey = () => {};

  return (
    <SettingsContext.Provider value={{ keys: {}, setKey }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);

  return (
    context ?? {
      keys: {},
      setKey: () => {},
    }
  );
}

// SettingsDialog component removed - AI features not supported in this branch
export function SettingsDialog() {
  return null;
}
